<template>
    <div class="card">
        <div class="card-header" id="headingTwo">
            <h5 class="mb-0">
                <button v-b-toggle.collapse-case-filters class="btn btn-link" id="toggle-case-filters-button">
                    <arrow-right-drop-circle-outline :size="17" />
                    <span>
                        {{ caseTitle }}
                        <span
                            v-show="clauseCount > 0"
                        >({{ clauseCount }})</span>
                    </span>
                </button>
            </h5>
        </div>

        <b-collapse
            id="collapse-case-filters"
            accordion="collapse-case-filters-accordion"
            role="tabpanel"
        >
            <div class="card-body">
                <div class="d-flex flex-column subQueryItemContainer">
                    <int-range 
                        ref="startAge"
                        queryName="Patient age at case start"
                        queryField="Case.PatientAgeAtCaseStart"
                        category="Case"
                        class="subQueryItem"
                        :min="0"
                        :max="120"
                        id="patient-age"
                    />
                    <userEnabledDateSubquery
                        ref="startDate"
                        class="subQueryItem"
                        queryName="Startdate"
                        category="Case"
                        queryField="Case.StartDate"
                        fieldType="YearMonthDay"
                        v-if="startDateEnabled"
                    />
                    <binarySubQueryItem
                        ref="completed"
                        class="subQueryItem"
                        type="YesOrNo"
                        category="Case"
                        queryField="Case.IsCompleted"
                        queryName="Case is completed"
                        v-if="completedEnabled"
                    />
                    <binarySubQueryItem
                        ref="hasSurgery"
                        class="subQueryItem"
                        type="YesOrNo"
                        category="Case"
                        queryField="Case.HasSurgeryRecord"
                        queryName="Case has surgery record"
                        v-if="hasSurgeryEnabled"
                    />
                    <binarySubQueryItem
                        ref="hasRelapse"
                        class="subQueryItem"
                        type="YesOrNo"
                        category="Case"
                        queryField="Case.HasRelapseRecord"
                        queryName="Case has relapse record"
                        v-if="hasRelapseEnabled"
                    />
                    <binarySubQueryItem
                        ref="hasFollowUp"
                        class="subQueryItem"
                        type="YesOrNo"
                        category="Case"
                        queryField="Case.HasFollowUpRecords"
                        queryName="Case has follow-up records"
                        v-if="hasFollowUpEnabled"
                    />
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import binarySubQueryItem from "./subquery-binary-item.vue";
import userEnabledDateSubquery from "./user-enabled-date.vue";
import intRange from "./int-range.vue";
import { mapState } from "vuex";
import { BCollapse } from "bootstrap-vue";
import ArrowRightDropCircleOutline from "vue-material-design-icons/ArrowRightDropCircleOutline.vue";

export default {
    props: {
        module: String,
    },
    data() {
        return {
            mode: "fold",
        };
    },
    components: {
        binarySubQueryItem: binarySubQueryItem,
        userEnabledDateSubquery: userEnabledDateSubquery, intRange,
        BCollapse,
        ArrowRightDropCircleOutline,
    },
    computed: {
        ...mapState({
            caseQuery: function (state) {
                return state.caseQuery;
            },
        }),
        clauseCount: function (state) {
            return Object.keys(this.caseQuery || {}).length;
        },
        startDateEnabled: function () {
            return true;
        },
        completedEnabled: function () {
            return this.module === "tumour";
        },
        hasSurgeryEnabled: function () {
            return true;
        },
        hasRelapseEnabled: function () {
            return this.module === "tumour";
        },
        hasFollowUpEnabled: function () {
            return this.module === "tumour";
        },
        caseTitle: function() {
            return this.$i18n.CASE_QUERY_TITLE;
        }
    },
    methods: {
        reboot() {
            for (var ref in this.$refs) this.$refs[ref].reboot();
        },
        toggleSubQueryDisplay: function () {
            this.mode === "fold" ? (this.mode = "unfold") : (this.mode = "fold");
        },
    },
};
</script>

<style scoped>
.subQueryItem {
    background: white !important;
    margin-left: 15px;
}

.subQueryHeader {
    background: #f2f7f8 !important;
}

.subQueryItemContainer {
    width: 80%;
}

.card {
    margin: 0;
    padding: 0;
}

.card-header {
    padding: 0rem;
}

.card-body {
    padding-top: 20px;
    padding-bottom: 20px;
}

.dx-item-content {
    font-weight: normal !important;
}

#patient-age {
    margin-bottom: 10px;
}
</style>
